import { createSelector } from 'reselect';
import ReceptaclesInPredesNotInCarditSummaryColumns
  from '../../containers/ReceptaclesInPredesNotInCarditSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .RECEPTACLES_IN_PREDES_NOT_IN_CARDIT_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, ReceptaclesInPredesNotInCarditSummaryColumns);
